import React, { useEffect, useState } from "react";
import { Formik, FormikConsumer, useFormik } from "formik";
// import * as Yup from "yup";
import {
  TextField,
  Button,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Box,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from "../../../components/common/Card";
// import { addFuelPurchase } from "../../services/FuelService";
import { toast } from "react-toastify";
import TripDetailsForm from "../../../components/common/TripDetailForm";
import {
  getPortalFields1,
  saveDetailsTrips,
  uploadfilesgeneric,
  vehicleListVendors,
} from "../../../services/vehicleService";
import { useDispatch } from "react-redux";
import { setLoader } from "../../../redux/features/authSliceandSidebar";
import { useNavigate } from "react-router-dom";
import { updateMaintenance } from "../../../services/maintenanceService";
import moment from "moment";

const fuelTypes = ["Diesel", "Petrol", "Electric"];

const EditMaintenance = () => {
  const [fuelList, setFuelList] = useState([]);
  const [detailObj, setDetailObj] = useState(null);
  const [key, setKey] = useState(Math.random());
  const [prefilledFields, setPrefilledFields] = useState([]);
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [singleArray, setSingleArray] = useState([]);
  const [uploadfiles, setUploadfiles] = useState([]);

  const navigate = useNavigate();

  // const  []
  const formik = useFormik({
    initialValues: {
      siteId: null,
      shiftId: null,
      tripDate: null,
      siteIdState: null,
      tripDateState: new Date(),
      vehicleTypeId: null,
      vehicleName: "",
      shiftName: "",
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      // console.log(values);
      let arr = [];

      if (singleArray?.length == 0) {
        toast.error("Atleast one entry is required for submit");
        return;
      }

      if (uploadfiles?.length === 0) {
        toast.error("files are required");
        return;
      }

      singleArray?.forEach((ele) => {
        let formdata = ele;
        arr.push(formdata);
      });

      const indiaTime = new Date().toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      // console.log(arr);
      let newObj = {
        id: singleArray[0].id,
        outComment: singleArray[0].outComment,
        outDate: moment(new Date()).format("DD-MM-YYYY") + " " + indiaTime,
      };

      // console.log(arr1);
      dispatch(setLoader(true));
      await updateMaintenance(newObj).then((res) => {
        dispatch(setLoader(false));
        if (res && res.data.statusDescription.statusCode == 200) {
          toast.success(res.data.statusDescription.description);
          let arr = [];

          if (res.data.data) {
            uploadfilesApi(res.data.data.id);
          }
          //   if (res.data.tripdetaillog1?.length > 0) {
          //     res.data.tripdetaillog1.forEach((x) => {
          //       arr.push(x.tripId);
          //     });
          //   }
          // console.log(arr);
          //   resetForms();
          //   uploadfilesApi(arr);
        } else {
          toast.error(res.data.statusDescription.description);
        }
      });
    },
  });

  const uploadfilesApi = async (id) => {
    // console.log(arr);
    let formdata = new FormData();

    formdata.append("maintenanceId", id);

    uploadfiles.forEach((x) => {
      formdata.append("files", x);
    });

    // toast.error(uploadfiles.length);

    formdata.append("userId", localStorage.getItem("userId"));
    dispatch(setLoader(true));
    try {
      await uploadfilesgeneric(
        formdata,
        "/maintainence/v1/save-attachments"
      ).then((res) => {
        if (res.data.statusDescription.statusCode == 200) {
          // console.log("files saved ");
          dispatch(setLoader(false));
          setUploadfiles([]);
          navigate("/viewInMaintenance");
        } else {
          toast.error("Attachment not uploaded");
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("detailsObj") != null) {
      setShowForm(false);
      dispatch(setLoader(true));
      let obj = JSON.parse(localStorage.getItem("detailsObj"));
      console.log(obj);
      getPortalFields(obj);

      //   setPrefilledFields(localStorage.getItem("detailObj"));
    }
  }, []);

  const getPortalFields = async (details) => {
    let formdata = {
      fieldMenu: "Update Maintenance",
      fieldCategory: details.vehicleType,
    };

    await getPortalFields1(formdata).then((res) => {
      dispatch(setLoader(false));
      if (res.data.statusDescription.statusCode == 200) {
        console.log(res);

        let arr = res.data.portalFields.map((x) => {
          return { ...x };
        });
        setKey(Math.random());
        // setPortalfields(arr);

        setDetailObj(details);
        setKey(Math.random());
        setShowForm(true);
        setPrefilledFields(res.data.portalFields);
      } else {
      }
    });
  };
  const EditVendorDetailsApi = async (details) => {
    console.log(details);
    let formdata = {
      vehicleTypeId: details.vehicleTypeId,
      shiftId: details.shiftId,
      siteId: details.siteId,
      tripDate: details.tripDate,
      fieldCategory: details.vehicleType,
      fieldMenu: "Update Maintenance",
    };

    await vehicleListVendors(formdata).then((res) => {
      dispatch(setLoader(false));
      if (res && res.data?.statusDescription?.statusCode == 200) {
        console.log(res.data);
        console.log(detailObj);
        setDetailObj(details);
        setKey(Math.random());
        setShowForm(true);
        setPrefilledFields(res.data.portalFields);
      } else {
      }
    });
    console.log(formdata);
  };

  return (
    <Card
      title={
        "Update Maintenance Details " +
        detailObj?.vehicleName +
        " - " +
        detailObj?.vendorName +
        " - " +
        detailObj?.id
      }
    >
      <Box className="container mt-4">
        {showForm && (
          <TripDetailsForm
            key={key}
            prefilled={detailObj}
            editData={detailObj}
            formFields={prefilledFields}
            exportAddition={(e) => {
              console.log(e);
              let arr = [];

              arr.push(e);

              let fileArr = [];

              Object.keys(e).forEach((x) => {
                if (x.includes("file")) {
                  console.log(e[x]);
                  e[x].forEach((fl) => {
                    fileArr.push(fl);
                  });
                  // filearr.push(e[x][0]);
                }
              });

              setUploadfiles(fileArr);

              console.log(e);
              setSingleArray(arr);
              let y;
              formik.handleSubmit(y);
            }}
          />
        )}
      </Box>
    </Card>
  );
};

export default EditMaintenance;
